/*
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CrownCapNames } from './CrownCapNames';
import { Buffers } from '@sick-davinci/device-communication';
import { Materials } from '@sick-davinci/glow';
import { FrontSide, BackSide, DoubleSide, BufferGeometry, BufferAttribute, Uint16BufferAttribute, VertexColors, NoColors, Color, Mesh, } from 'three';
class CrownMesh extends Mesh {
    constructor(geo, _params) {
        super(geo, Materials.create({ type: 'standard', params: _params }));
        this._params = _params;
    }
    updateDecoration(deco) {
        this._params.side = (CrownMesh.sides).get(deco.VisibleFaces);
        if (!!deco.SurfaceColor) {
            const c = deco.SurfaceColor;
            this._params.color = new Color(c.R, c.G, c.B).multiplyScalar(1 / 255);
        }
        this.material = Materials.create({ type: 'standard', params: this._params });
    }
}
CrownMesh.sides = new Map([['FRONT', FrontSide], ['BACK', BackSide], ['FRONT_AND_BACK', DoubleSide]]);
/**
 * This class creates a THREE.Mesh from a Crown Mesh
 */
export class CrownMeshCap {
    getName() {
        return CrownCapNames.CROWNMESH;
    }
    doClassToCapabilityMapping(map) {
        map.set(CrownMeshCap.className, CrownCapNames.CROWNMESH);
        map.set(CrownMeshCap.decoClassName, CrownCapNames.CROWNMESH);
    }
    call(objectIn, sceneIn) {
        const { payload } = objectIn;
        if (payload.Type === CrownMeshCap.className) {
            const deco = !!payload.Decorations && payload.Decorations.length === 1 ? payload.Decorations[0].data : undefined;
            payload.Iconics.forEach((icon) => {
                const meshDesc = icon.data;
                const geo = new BufferGeometry();
                const vertices = Buffers.from(meshDesc.Vertices.data).correctByteOrder(meshDesc.Vertices.endian).as(Float32Array);
                const normals = Buffers.from(meshDesc.Normals.data).correctByteOrder(meshDesc.Normals.endian).as(Float32Array);
                let colors = Buffers.from(meshDesc.Colors.data).correctByteOrder(meshDesc.Colors.endian).as(Float32Array);
                if (colors.length === 0) {
                    colors = Buffers.from(meshDesc.Intensities.data).reinterpret(Float32Array).spread(3).as(Float32Array);
                }
                const indices = Buffers.from(meshDesc.Indices.data).correctByteOrder(meshDesc.Indices.endian).as(Int32Array);
                geo.setIndex(new Uint16BufferAttribute(indices, 1));
                geo.addAttribute('position', new BufferAttribute(vertices, 3));
                let vertexColors = NoColors;
                if (colors.length > 0) {
                    geo.addAttribute('color', new BufferAttribute(colors, 3));
                    vertexColors = VertexColors;
                }
                if (normals.length > 0) {
                    geo.addAttribute('normals', new BufferAttribute(normals, 3));
                }
                else {
                    geo.computeVertexNormals();
                }
                const params = { vertexColors, side: CrownMesh.sides.get(deco.VisibleFaces) };
                if (!!deco.SurfaceColor) {
                    const c = deco.SurfaceColor;
                    params.color = new Color(c.R, c.G, c.B).multiplyScalar(1 / 255);
                }
                const mesh = new CrownMesh(geo, params);
                mesh.name = objectIn.name;
                sceneIn.addToParent(objectIn.parent || '', mesh);
                sceneIn.setTag(objectIn.tag, mesh);
            });
            return true;
        }
        return false;
    }
    update(objectIn, sceneIn) {
        const { payload: { Decoration, IconicId } } = objectIn;
        if (Decoration.class === CrownMeshCap.decoClassName) {
            const mesh = sceneIn.getObjectByName(IconicId);
            if (mesh != null) {
                mesh.updateDecoration(Decoration.data);
                return true;
            }
        }
        return false;
    }
}
CrownMeshCap.className = 'MESH';
CrownMeshCap.decoClassName = 'View.MeshDecoration';
//# sourceMappingURL=CrownMeshCap.js.map